module.exports = {"654002001":"萨依布依街道","654002002":"墩买里街道","654002003":"伊犁河路街道","654002004":"喀赞其街道","654002005":"都来提巴格街道","654002006":"琼科瑞克街道","654002007":"艾兰木巴格街道","654002008":"解放路街道","654002009":"伊宁市边境经济合作区管委会","654002100":"巴彦岱镇","654002101":"潘津镇","654002200":"英也尔乡","654002201":"汉宾乡","654002202":"塔什科瑞克乡","654002203":"喀尔墩乡","654002204":"托格拉克乡","654002205":"克伯克圩孜乡","654002206":"达达木图乡","654002400":"伊犁州农业良种繁育中心","654002401":"伊宁市园艺场","654002402":"伊犁州奶牛场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654002.json
// module id = 2908
// module chunks = 0